import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgLaptop = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M20.5 2.5h-17a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2Zm-17 2h17v10h-17v-10ZM22 18.5a1 1 0 0 1 .117 1.993L22 20.5H2a1 1 0 0 1-.117-1.993L2 18.5h20Z" />
      <path d="M13 5.5a1 1 0 0 1 .117 1.993L13 7.5h-2a1 1 0 0 1-.117-1.993L11 5.5h2Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgLaptop)
const Memo = memo(ForwardRef)
export default Memo
